import { render, staticRenderFns } from "./searchPlus.vue?vue&type=template&id=08914672&scoped=true"
import script from "./searchPlus.vue?vue&type=script&lang=js"
export * from "./searchPlus.vue?vue&type=script&lang=js"
import style0 from "./searchPlus.vue?vue&type=style&index=0&id=08914672&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08914672",
  null
  
)

export default component.exports